// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPinFilled = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12.692 4.164l1.415-1.414 7.07 7.071-1.413 1.414-.708-.707-4.95 6.364 1.415 1.414-1.414 1.415-4.243-4.243-4.95 4.95H3.5v-1.415l4.95-4.95-4.243-4.242 1.414-1.414L7.036 9.82 13.4 4.87z" />
  );
export default SvgIconPinFilled;
